export default __webpack_public_path__ + "static/step-2-e843112ce55c1070b1716638ec0a73cd.webp";